module.exports = __webpack_public_path__ + "static/media/Jomolhari-01.777b15dd.svg";